import { POSConnection } from './posConnection.dto';
export class POSSyncRequestDto{
    data: POSConnection;
    deviceUID: string;
    customerID?: number;
    posDeviceID?: number;
    apiKey: string;
}